import { Box, Image } from '@chakra-ui/react';

import Loader from 'Asset/image/loading-siglive.svg';

import styles from './styles.module.css';

const LoadingState = () => {
  return (
    <Box className={styles['loading-state__container']}>
      <Image className={styles['loading-state__image']} src={Loader} alt="loading" />
    </Box>
  );
};

export default LoadingState;
